export const GET_PROJECT_MONITORS = 'get-project-monitors';
export const GET_DATE_RANGE = 'get-date-range';
